import { Component, Input } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import * as moment from 'moment';
import { Transaction } from '../../../../core/models/transaction';
import { TransactionMove, transactionMoves, transactionStyle, TransactionTone } from '../../models/transaction-style';

interface TimelineEntry {
  transaction: Transaction;
  label: string;
  icon: IconDefinition;
  tone: TransactionTone;
  moves: TransactionMove[];
  qtyChanged: boolean;
}

@Component({
  selector: 'inventory-transaction-timeline',
  templateUrl: './transaction-timeline.component.html',
  styleUrls: ['./transaction-timeline.component.scss']
})
export class TransactionTimelineComponent {
  public faArrowRight = faArrowRight;
  public entries: TimelineEntry[] = [];

  @Input() set transactions(value: Transaction[] | null | undefined) {
    this.entries = this.buildTimeline(value);
  }

  trackTransaction(_: number, entry: TimelineEntry): number | undefined {
    return entry.transaction.id;
  }

  private buildTimeline(transactions: Transaction[] | null | undefined): TimelineEntry[] {
    return [...(transactions ?? [])]
      .sort((a, b) => moment(b.createdDate).valueOf() - moment(a.createdDate).valueOf())
      .map(t => {
        const { label, icon, tone } = transactionStyle(t.transactionType);
        return {
          transaction: t,
          label,
          icon,
          tone,
          moves: transactionMoves(t),
          qtyChanged: t.originalQty != null && t.adjustedQty != null && t.originalQty !== t.adjustedQty,
        };
      });
  }
}
